import React from 'react';
import '../../css/admin.css';
import MainAdmin from '../../components/MainAdmin';
import Footer from '../../components/Footer';
import ModalCodigo from '../../components/ModalCodigo';
import ModalRecuperar from '../../components/ModalRecuperar';
import NavBarAdmin from '../../components/NavBarAdmin';
import { NavBarAdmin2 } from '../../components/NavBarAdmin2';
import logoCalendario from '../../assets/logoCalendario.png';
import logoPanel from '../../assets/logoPanel.png';
import logoEmpresas from '../../assets/logoEmpresas.png';
import logoAnalisis from '../../assets/logoAnalisis.png';
import logoConfiguracion from '../../assets/logoConfiguracion.png';
import logoReuniones from '../../assets/logoReuniones.png';
import MainAdmin2 from '../../components/MainAdminN';

function Administrador(props) {

    const itemsNavBar = [
        { id: 'tab-panel', nombre: 'Panel de control', logo: logoPanel, url: '/' },
        { id: 'tab-eventos', nombre: 'Eventos', logo: logoCalendario, url: '/eventos' },
        { id: 'tab-empresas', nombre: 'Empresas', logo: logoEmpresas, url: '/empresas' },
        { id: 'tab-reuniones', nombre: 'Reuniones', logo: logoReuniones, url: '/reuniones' },
        { id: 'tab-configuracion', nombre: 'Configuración', logo: logoConfiguracion, url: '/configuracion' }
    ];
    /*const itemsNavBar = [
            { id: 'tab-panel', nombre: 'Panel de control', logo: logoPanel, url: '/' },
            { id: 'tab-eventos', nombre: 'Eventos', logo: logoCalendario, url: '/eventos' },
            { id: 'tab-empresas', nombre: 'Empresas', logo: logoEmpresas, url: '/empresas' },
            { id: 'tab-reuniones', nombre: 'Reuniones', logo: logoReuniones, url: '/reuniones' },
            { id: 'tab-analisis', nombre: 'Análisis', logo: logoAnalisis, url: '/analisis' },
            { id: 'tab-configuracion', nombre: 'Configuración', logo: logoConfiguracion, url: '/configuracion' }
        ]; */
    return (
        <>{/*
            <NavBarAdmin />
            <MainAdmin seccion={props.seccion}/>
            <Footer/>
            <ModalCodigo/>
            <ModalRecuperar/>*/}

            <div className='container rounded-4 overflow-hidden contAdmin' id="contMainAdmin">
                <div className='row  navAdmin' id="rowMainAdmin">
                    <div id="colNavBar" className='col-3 colNavBar px-0 position-relative transition-all-1s '>
                        <NavBarAdmin2 itemsNavBar={itemsNavBar} />
                    </div>
                    <div className='col px-0'>
                        <MainAdmin2 seccion={props.seccion} />
                    </div>
                </div>
            </div>
            <Footer isVisibleMobile={true} />
            {/*
            <ModalCodigo />
            <ModalRecuperar />*/}
        </>
    );
}


export default Administrador;